import { useNavigate } from 'react-router-dom';
import { BookOpenIcon } from '@heroicons/react/24/outline';
import { PageShell, PageTopRow, ContentCard } from '@/components/ui/page-shell';
import { guides } from '@/guides';

/**
 * Guides — practical playbooks for running outreach well. Index page:
 * one card per guide, reading order, click through to the reader.
 */
export function Guides() {
  const navigate = useNavigate();

  return (
    <PageShell>
      <PageTopRow>
        <h1 className="text-lg font-semibold">Guides</h1>
      </PageTopRow>

      <ContentCard>
        {guides.length === 0 ? (
          <div className="h-full flex flex-col items-center justify-center text-center text-foreground">
            <BookOpenIcon className="h-10 w-10 mx-auto mb-3" />
            <p>No guides yet.</p>
            <p className="text-xs mt-1">Playbooks for cold email, deliverability and list building will live here.</p>
          </div>
        ) : (
          <div className="max-w-3xl mx-auto">
            <p className="text-sm text-muted-foreground mb-6">
              The fundamentals of cold outreach, in reading order. Written for 2026, not 2021.
            </p>
            <div className="flex flex-col gap-3">
              {guides.map((g, i) => (
                <button
                  key={g.slug}
                  onClick={() => navigate(`/dashboard/guides/${g.slug}`)}
                  className="text-left p-6 rounded-inner border border-panel-border bg-card shadow-md cursor-pointer transition-colors hover:border-primary/40 focus-visible:outline-2 focus-visible:outline-primary"
                >
                  <div className="flex items-baseline gap-3">
                    <span className="text-xs text-muted-foreground tabular-nums shrink-0">{String(i + 1).padStart(2, '0')}</span>
                    <div className="min-w-0">
                      <p className="text-base font-medium">{g.title}</p>
                      <p className="text-sm text-content-strong mt-1">{g.oneLiner}</p>
                    </div>
                  </div>
                </button>
              ))}
            </div>
          </div>
        )}
      </ContentCard>
    </PageShell>
  );
}

export default Guides;
